import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';

class ALink extends React.Component {
  render() {
    const to = {pathname: this.props.to, query: this.props.linkQuery};
    const props = {
      to,
      title: this.props.title,
      className: this.props.className,
      activeClassName: this.props.activeClassName,
      style: this.props.style,
      onClick: this.props.onClick,
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave
    };

    return (
      <Link {...props}>{this.props.children}</Link>
    );
  }

  static propTypes = {
    to: PropTypes.string.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    activeClassName: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    linkQuery: PropTypes.object,
    children: PropTypes.node
  }
}

export default connect((state) => ({linkQuery: state.mode.linkQuery}))(ALink);



// WEBPACK FOOTER //
// ./components/ALink.js